import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../../Features/storefrontSlice';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import SearchIcon from '../../../../../Assets/OrderManagement/SearchIcon.svg';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { useNavigate } from 'react-router-dom';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';
import { apiV1 } from '../../../../../Auth/Interceptor';

function SelectCategory() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sectionFormType = useSelector((state) => state.storefront.sectionFormType);
    const selectedCarouselBannerSection = useSelector((state) => state.storefront.selectedCarouselBannerSection);

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const {
        setSelectedCollection,
        setSelectedProducts,
        setSelectedCustomCollection,
        setSelectedCategory,

        singleBanner,
        defaultSingleBanner,
        setSingleBanner,

        singleBannerDesktop,
        setSingleBannerDesktop,
        setCarouselBanner,
        setCarouselBannerDesktop,
    } = useContext(StorefrontContext);

    const [categories, setCategories] = useState([]);

    const [selectedCategoryId, setSelectedCategoryId] = useState({});

    const [categorySearchList, setCategorySearchList] = useState([]);

    const [categorySearchText, setCategorySearchText] = useState('');

    const [buttonAvailable, setButtonAvailable] = useState(false);

    const handleCategoryClick = (e) => {
        setSelectedCategoryId(e.target.value);
    }

    const handleCategorySearch = (e) => {
        console.log(e.target.value);
        setCategorySearchText(e.target.value);
    }

    const handleCategorySearchKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(categorySearchText) {
                const filteredList = categories.filter(category => category.categoryName.toLowerCase().includes(categorySearchText.toLowerCase()));
                setCategorySearchList(filteredList);
            }
        }
    }

    const handleSetCategory = () => {
        if(buttonAvailable) {
            const category = categorySearchList.find(item => item.id === selectedCategoryId);
            if(sectionFormType === 'SINGLE_BANNER') {
                setSingleBanner({
                    ...defaultSingleBanner,
                    image: singleBanner.image,
                    category: category,
                });
            }
            if(sectionFormType === 'SINGLE_BANNER_DESKTOP') {
                setSingleBannerDesktop({
                    ...defaultSingleBanner,
                    image: singleBannerDesktop.image,
                    category: category,
                });
            }
            if(sectionFormType === 'CAROUSEL_BANNER') {
                setCarouselBanner((prevCarouselBanner) =>
                    prevCarouselBanner.map((item) =>
                        item.title === selectedCarouselBannerSection
                            ? { ...item, link: { ...defaultSingleBanner, category: category } } 
                            : item
                    )
                );
            }
            if(sectionFormType === 'CAROUSEL_BANNER_DESKTOP') {
                setCarouselBannerDesktop((prevCarouselBanner) =>
                    prevCarouselBanner.map((item) =>
                        item.title === selectedCarouselBannerSection
                            ? { ...item, link: { ...defaultSingleBanner, category: category } } 
                            : item
                    )
                );
            }
            setSelectedCategory({});
            setSelectedCollection({});
            setSelectedCustomCollection({});
            setSelectedProducts([]);
            dispatch(closeModal());
        }
        else {
            showToast('Please select a collection.', 'warning');
        }
    }

    const handleCreateCategory = () => {
        dispatch(closeModal());
        navigate('/collections/categories/add-category');
    }

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await apiV1.get('category/getAll');
                if(response?.status === 200) {
                    setCategories(response.data.data.category);
                    setCategorySearchList(response.data.data.category);
                }
                else {
                    showToast('Error fetching categories.', 'error');
                }
            }
            catch(err) {
                showToast('Error fetching categories.', 'error');
            }
        }

        fetchCategories();
    }, []);

    useEffect(() => {
        if(!categorySearchText) {
            setCategorySearchList(categories);
        }
        // eslint-disable-next-line
    }, [categorySearchText]);

    useEffect(() => {
        if(selectedCategoryId) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [selectedCategoryId]);

    return (
        <div className='w-[28%] rounded-[20px] overflow-hidden bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D] relative'>
            <div className="flex items-center justify-between pt-[18px] pl-6 pr-2 w-full">
                <h1 className='font-semibold text-2xl text-[#121212]'>Link to category</h1>

                <button className='size-11 flex items-center justify-center outline-none' onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-4 py-[10px] rounded-lg flex items-center gap-1 mx-6 mt-2">
                <div className="size-5 flex items-center justify-center">
                    <img src={SearchIcon} alt="" />
                </div>

                <input 
                    name='category' 
                    id='category' 
                    className='w-[calc(100%-20px)] bg-transparent outline-none font-medium text-[14px] leading-[22px] text-[#121212] placeholder:text-[#666666]' 
                    type="text" 
                    placeholder='Search category' 
                    value={categorySearchText} 
                    onChange={handleCategorySearch} 
                    onKeyDown={handleCategorySearchKeyDown} 
                />
            </div>

            <div className="mt-4 flex flex-col mb-[84px] max-h-96 overflow-y-scroll no-scrollbar">
                {
                    categories.length > 0 ? 
                    <>
                        {categorySearchList?.map(category => {
                            return (
                                <label htmlFor={`${category.id}-radio`} key={category.id} className="px-6 py-3 flex items-center gap-2 hover:bg-[#F5F5F5] cursor-pointer">
                                    <div className="cursor-pointer size-4 flex items-center justify-center">
                                        <div className={`size-full rounded-full border flex items-center justify-center ${selectedCategoryId === category.id ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                            {
                                                selectedCategoryId === category.id && 
                                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                                            }
                                        </div>
                                    </div>

                                    <div className='w-[calc(100%-16px-8px)] select-none flex items-center gap-2'>
                                        <input 
                                            id={`${category.id}-radio`} 
                                            value={category.id} 
                                            type="radio" 
                                            checked={selectedCategoryId === category.id} 
                                            onChange={handleCategoryClick} 
                                            className='hidden' 
                                        />

                                        <div className="size-[52px] rounded-[7px] overflow-hidden flex items-center justify-center bg-[#D9D9D9]">
                                            <img className='size-full object-cover' src={getCachedMediaUrl(category?.categoryImgUrl[0])} alt="" />
                                        </div>

                                        <p className='w-[calc(100%-52px-8px)] line-clamp-1 font-medium text-[16px] leading-5 text-[#000000]'>{category.categoryName}</p>
                                    </div>
                                </label>
                            )
                        })}
                    </> : 
                    <div className='px-6 pt-3 pb-4'>
                        <p className='italic text-[14px] leading-[26px] text-[#666666]'>Oops! Looks like you don't have any categories. <span onClick={handleCreateCategory} className='cursor-pointer text-[#4F46E5]'>Create one here</span>.</p>
                    </div>
                }
            </div>

            <div className="p-6 absolute left-0 bottom-0 w-full bg-[#FFFFFF] shadow-[0px_-3px_6px_0px_#0000001F]">
                <button onClick={handleSetCategory} className={`w-full px-4 py-[6px] rounded-md font-semibold text-[12px] leading-6 text-buttonText ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'}`}>Set</button>
            </div>
        </div>
    );
}

export default SelectCategory;
